import { __awaiter, __generator } from '../node_modules/tslib/tslib.es6.js';
import { createPredicate } from './condition.js';

var SCRIPT_SRC = 'https://c.amazon-adsystem.com/aat/amzn.js';
var SCRIPT_ID = 'amzn-pixel';
var PROVIDER = 'AmazonAds';
var debug = false;
var initialized = false;
var log = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return debug && 
    // eslint-disable-next-line no-console
    console.info.apply(
    // eslint-disable-next-line no-console
    console, ['[amazonAds]'].concat(args));
};
/**
 * Check if Amazon Ads script is loaded
 */
var isLoaded = function () {
    return typeof window !== 'undefined' && !!window.amzn;
};
/**
 * Load the Amazon Ads tracking script
 */
var loadScript = function () {
    return new Promise(function (resolve, reject) {
        if (isLoaded()) {
            log('Amazon Ads script already loaded');
            resolve();
            return;
        }
        if (typeof window === 'undefined') {
            reject(new Error('Cannot load Amazon Ads script in non-browser environment'));
            return;
        }
        // Check if script tag already exists
        if (document.getElementById(SCRIPT_ID)) {
            log('Amazon Ads script tag already exists');
            resolve();
            return;
        }
        log('Loading Amazon Ads script...');
        var script = document.createElement('script');
        script.src = SCRIPT_SRC;
        script.id = SCRIPT_ID;
        script.async = true;
        script.onload = function () {
            log('Amazon Ads script loaded successfully');
            resolve();
        };
        script.onerror = function (error) {
            log('Failed to load Amazon Ads script', error);
            reject(new Error('Failed to load Amazon Ads script'));
        };
        var firstScript = document.getElementsByTagName('script')[0];
        (firstScript === null || firstScript === void 0 ? void 0 : firstScript.parentNode)
            ? firstScript.parentNode.insertBefore(script, firstScript)
            : document.head.appendChild(script);
    });
};
/**
 * Initialize Amazon Ads tracking
 */
var initializeAmazonAds = function (brandId, pixel) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!pixel.region || !pixel.amazonTagId) {
                    log('Amazon Ads config is missing required fields', pixel);
                    return [2 /*return*/];
                }
                if (initialized) {
                    log('Amazon Ads already initialized');
                    return [2 /*return*/];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, loadScript()];
            case 2:
                _a.sent();
                if (!window.amzn) {
                    log('Amazon Ads script loaded but amzn object not available');
                    return [2 /*return*/];
                }
                // Set region and add tag
                window.amzn('setRegion', pixel.region);
                window.amzn('addTag', pixel.amazonTagId);
                initialized = true;
                log('Amazon Ads initialized with config', { brandId: brandId, region: pixel.region, amazonTagId: pixel.amazonTagId });
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                log('Failed to initialize Amazon Ads', error_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Track an Amazon Ads event
 */
var trackAmazonEvent = function (eventName, params) {
    if (!isLoaded()) {
        log('Cannot track event - Amazon Ads not initialized');
        return;
    }
    try {
        if (params) {
            window.amzn('trackEvent', eventName, params);
        }
        else {
            window.amzn('trackEvent', eventName);
        }
        log("Tracked ".concat(eventName, " event"), params);
    }
    catch (error) {
        log("Failed to track ".concat(eventName, " event"), error);
    }
};
/**
 * Initialize Amazon Ads with configuration
 */
var init = function (config) {
    return initializeAmazonAds(config.brandId, {
        pixelProvider: PROVIDER,
        region: config.region,
        amazonTagId: config.amazonTagId
    });
};
var amazonAds = {
    enableDebug: function () { debug = true; },
    track: function (_a) {
        var _this = this;
        var brandId = _a.brandId, pixels = _a.pixels, eventName = _a.eventName, eventType = _a.eventType, eventPayload = _a.eventPayload;
        // Process each Amazon Ads pixel
        pixels.forEach(function (pixel) { return __awaiter(_this, void 0, void 0, function () {
            var predicate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Apply event filter if present
                        if (pixel.eventFilter) {
                            predicate = createPredicate(pixel.eventFilter);
                            if (!predicate(eventPayload)) {
                                log('eventFilter not matched', pixel.eventFilter, pixel.pixelId, eventName, eventPayload);
                                return [2 /*return*/];
                            }
                        }
                        // Initialize Amazon Ads
                        return [4 /*yield*/, initializeAmazonAds(brandId, pixel)];
                    case 1:
                        // Initialize Amazon Ads
                        _a.sent();
                        if (!initialized)
                            return [2 /*return*/];
                        // Track the appropriate events
                        switch (eventType) {
                            default:
                                trackAmazonEvent(eventName, eventPayload);
                                break;
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    },
    // For backward compatibility
    init: init,
    isLoaded: isLoaded
};

export { amazonAds as default };
//# sourceMappingURL=amazonAds.js.map
